import T from 'i18n-react';
import { INSPECTION_LANG_PATH } from 'shared/path';
import { setLanguageLocale } from 'util/icwUtility';

// TODO: try to optimize => do not load from init
setLanguageLocale(T, [INSPECTION_LANG_PATH]);

export const inspectionType = [
  {
    label: T.translate('inspectionJobWorkspace.finalRandomInspection'),
    value: 'Final Random Inspection',
  },
  {
    label: T.translate('inspectionJobWorkspace.loadingInspection'),
    value: 'Loading Inspection',
  },
  {
    label: T.translate('inspectionJobWorkspace.duringProductionInspection'),
    value: 'During-production Inspection',
  },
  {
    label: T.translate('inspectionJobWorkspace.reInspection'),
    value: 'Re-Inspection',
  },
  {
    label: T.translate('inspectionJobWorkspace.initialProductionInspection'),
    value: 'Initial Production Inspection',
  },
  {
    label: T.translate('inspectionJobWorkspace.fabricInspection'),
    value: 'Fabric Inspection',
  },
  {
    label: T.translate('inspectionJobWorkspace.100%Inspection'),
    value: '100% Inspection',
  },
  {
    label: T.translate('inspectionJobWorkspace.vendorOwnInspection'),
    value: 'Vendor Own Inspection',
  },
  {
    label: T.translate('inspectionJobWorkspace.sampleCollection'),
    value: 'Sample Collection',
  },
  {
    label: T.translate('inspectionJobWorkspace.other'),
    value: 'Other',
  },
];

export const inspectionLevel = [
  {
    label: T.translate('inspectionJobWorkspace.i'),
    value: 'i',
  },
  {
    label: T.translate('inspectionJobWorkspace.ii'),
    value: 'ii',
  },
  {
    label: T.translate('inspectionJobWorkspace.iii'),
    value: 'iii',
  },
  {
    label: T.translate('inspectionJobWorkspace.s1'),
    value: 's1',
  },
  {
    label: T.translate('inspectionJobWorkspace.s2'),
    value: 's2',
  },
  {
    label: T.translate('inspectionJobWorkspace.s3'),
    value: 's3',
  },
  {
    label: T.translate('inspectionJobWorkspace.s4'),
    value: 's4',
  },
];

export const AQLLevel = [
  {
    label: '1.0',
    value: 1.0,
  },
  {
    label: '1.5',
    value: 1.5,
  },
  {
    label: '2.5',
    value: 2.5,
  },
  {
    label: '4.0',
    value: 4.0,
  },
  {
    label: '0',
    value: 0,
  },
  {
    label: '0.01',
    value: 0.01,
  },
  {
    label: '0.015',
    value: 0.015,
  },
  {
    label: '0.025',
    value: 0.025,
  },
  {
    label: '0.04',
    value: 0.04,
  },
  {
    label: '0.065',
    value: 0.065,
  },
  {
    label: '0.1',
    value: 0.1,
  },
  {
    label: '0.15',
    value: 0.15,
  },
  {
    label: '0.25',
    value: 0.25,
  },
  {
    label: '0.4',
    value: 0.4,
  },
  {
    label: '0.65',
    value: 0.65,
  },
  {
    label: '6.5',
    value: 6.5,
  },
  {
    label: '10',
    value: 10,
  },
  {
    label: '15',
    value: 15,
  },
  {
    label: '25',
    value: 25,
  },
];

export const productsRecord = [
  {
    label: 'smallProduct',
    id: 1,
    value: 1,
  },
  {
    label: 'bigProduct',
    id: 2,
    value: 2,
  },
];

export const currency = [
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'RMB',
    value: 'RMB',
  },
  {
    label: 'HKD',
    value: 'HKD',
  },
];

export const reportType = [
  {
    label: 'Report A',
    value: 'reportA',
  },
  {
    label: 'Report B',
    value: 'reportB',
  },
  {
    label: 'Report C',
    value: 'reportC',
  },
  {
    label: 'Report D',
    value: 'reportD',
  },
  {
    label: 'Report E',
    value: 'reportE',
  },
  {
    label: 'Individual',
    value: 'individual',
  },
];
